import { gql } from "graphql-request";

export const WorkforceFieldsFragment = gql`
  fragment WorkforceFieldsFragment on WorkforceSearchResult {
    workforceId
    name
    subdomain
    positionGroup
    startDate
    endDate
  }
`;
